var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHotelDetailFailed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 465,
    height: 141
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__m",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__a",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__c",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__d",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__f",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__h",
    x1: "166.329%",
    x2: "-5.793%",
    y1: "-5.265%",
    y2: "76.155%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3463E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF5A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__j",
    x1: "165.748%",
    x2: "-5.514%",
    y1: "-27.572%",
    y2: "86.711%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3463E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF5A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__k",
    x1: "165.748%",
    x2: "-5.514%",
    y1: "-27.572%",
    y2: "86.711%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3463E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF5A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__l",
    x1: "165.748%",
    x2: "-5.514%",
    y1: "-27.572%",
    y2: "86.711%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3463E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF5A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__b",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__n",
    x1: "64.925%",
    x2: "42.842%",
    y1: "-27.572%",
    y2: "86.711%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3463E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF5A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__o",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__p",
    x1: "166.329%",
    x2: "-5.793%",
    y1: "48.474%",
    y2: "50.722%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3463E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF5A7D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__q",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__r",
    x1: "50%",
    x2: "50%",
    y1: "-53.002%",
    y2: "63.463%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F75D65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#8B1A5E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "hotel-detail-failed_svg__s",
    x1: "80.91%",
    x2: "35.175%",
    y1: "-27.572%",
    y2: "86.711%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F3463E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF5A7D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "hotel-detail-failed_svg__e",
    d: "M.138.518h130.118v11.259H.138z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hotel-detail-failed_svg__i",
    d: "M.599.172h42.559v35.922H.599z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__a)",
    d: "M224.403 140.736c2.522-21.405 15.271-32.108 38.247-32.108 34.462 0 37.293-30.343 60.466-42.301 23.174-11.96 31.788 7.892 57.004-9.966 25.215-17.857 43.8-33.152 70.92-19.186 18.08 9.31 17.813 43.773-.8 103.388l-225.837.173z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__b)",
    d: "M151.791 7c5.982 0 11.128 3.576 13.417 8.707a7.89 7.89 0 015.197-1.943 7.92 7.92 0 017.14 4.488 5.875 5.875 0 012.08-.378 5.867 5.867 0 015.79 4.923c.737.665 1.592 1.41 2.565 2.236 3.414 2.897 15.4 4.421 35.96 4.573l-44.261-.001-.055.001h-.055l-9.102-.001-.062.001h-.062l-36.773-.001-.061.001h-38.05c12.911-.381 23.392-1.566 31.443-3.552a7.92 7.92 0 0111.563-10.548C140.798 10.483 145.888 7 151.791 7z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__c)",
    d: "M129.12 106.908c59.522-2.046 117.24-11.812 201.975 9.512 56.49 14.215 100.791 22.375 132.905 24.48H0c46.4-21.298 89.44-32.628 129.12-33.992z",
    opacity: 0.2,
    transform: "matrix(-1 0 0 1 464 0)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BA3761",
    strokeWidth: 0.924,
    d: "M194.895 73.373c13.569 7.58 26.805 8.767 39.708 3.561m-39.708-10.03c13.569 7.58 26.805 8.768 39.708 3.562"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    stroke: "#979797",
    strokeWidth: 0.749,
    d: "M294.85 25.189h-13.438v21.489h13.438v-21.49z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__d)",
    d: "M8.586 9.83h122.44v118.463H8.586z",
    transform: "translate(218.32 .011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A102D",
    d: "M226.906 9.841h122.44v12.671h-122.44z",
    opacity: 0.396
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(222.929 8.328)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "hotel-detail-failed_svg__g",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hotel-detail-failed_svg__e"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hotel-detail-failed_svg__f)",
    xlinkHref: "#hotel-detail-failed_svg__e"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#FA5263",
    strokeWidth: 2.218,
    mask: "url(#hotel-detail-failed_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.669 3.316H147.05"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "#FA5263",
    strokeWidth: 2.218,
    mask: "url(#hotel-detail-failed_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-21.669 7.937H147.05"
  }))), /*#__PURE__*/React.createElement("use", {
    fill: "url(#hotel-detail-failed_svg__h)",
    xlinkHref: "#hotel-detail-failed_svg__i",
    transform: "translate(266.253 92.211)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A102D",
    d: "M266.852 92.382h42.559v7.121h-42.559z",
    opacity: 0.396
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(229.414 101.473)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.429,
    cy: 10.153,
    fill: "url(#hotel-detail-failed_svg__j)",
    rx: 9.126,
    ry: 9.149
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.471,
    cy: 10.821,
    fill: "url(#hotel-detail-failed_svg__k)",
    rx: 7.916,
    ry: 7.936
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.555,
    cy: 11.077,
    fill: "url(#hotel-detail-failed_svg__l)",
    rx: 5.817,
    ry: 5.832
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 91.468,
    cy: 12.925,
    fill: "url(#hotel-detail-failed_svg__j)",
    rx: 9.126,
    ry: 9.149
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 108.51,
    cy: 8.048,
    fill: "url(#hotel-detail-failed_svg__k)",
    rx: 7.916,
    ry: 7.936
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.594,
    cy: 11.077,
    fill: "url(#hotel-detail-failed_svg__l)",
    rx: 5.817,
    ry: 5.832
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__m)",
    d: "M9.848 112.043h38.684v16.25H.607v-7.01a9.24 9.24 0 019.24-9.24zm81.242 0h38.685a9.24 9.24 0 019.24 9.24v7.01H91.092v-16.25z",
    transform: "translate(218.32 .011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A102D",
    d: "M270.17 22.33h1.844v68.383h-1.844zm34.106 0h1.844v68.383h-1.844z",
    opacity: 0.396
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__n)",
    d: "M53.012 2.131h33.599v93.801H53.012z",
    transform: "translate(218.32 .011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__o)",
    d: "M49.11.663h41.403v5.181H49.11z",
    transform: "translate(218.32 .011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6A102D",
    d: "M276.623 88.865h22.123v1.848h-22.123z",
    opacity: 0.396
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__p)",
    d: "M44.415 90.382h50.782v7.121H44.415z",
    transform: "translate(218.32 .011)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9EA8",
    d: "M276.576 106.922h23.857v21.382h-23.857z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#C0364A",
    strokeWidth: 0.749,
    d: "M288.076 106.922v21.382"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__q)",
    d: "M5.922.385h3.559v65.61H5.922z",
    transform: "translate(187 60.429)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__r)",
    d: "M1.76 62.629h11.354v5.545H1.76z",
    transform: "translate(187 60.429)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BA3761",
    strokeWidth: 0.924,
    d: "M187.035 72.167h14.474M189.801 65.9h10.139"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M242.704 35.979h11.673v18.137h-11.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M243.866 35.979h9.349v18.137h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__s)",
    d: "M3.855 1.883h9.349V20.02H3.855z",
    transform: "translate(240.011 34.096)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9EA8",
    d: "M243.866 35.979h9.349v9.069h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M240.992 35.409h15.269v1.422h-15.269z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M240.992 35.409h15.269v1h-15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M240.011 34.096h17.231v1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M240.011 34.096h17.231v1h-17.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M240.992 54.403h15.269v-1.422h-15.269z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M240.992 54.403h15.269v-1h-15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M240.011 55.716h17.231v-1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M240.011 55.716h17.231v-1h-17.231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M321.862 35.979h11.673v18.137h-11.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M323.024 35.979h9.349v18.137h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__s)",
    d: "M3.855 1.883h9.349V20.02H3.855z",
    transform: "translate(319.169 34.096)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9EA8",
    d: "M323.024 35.979h9.349v9.069h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M320.15 35.409h15.269v1.422H320.15z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M320.15 35.409h15.269v1H320.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M319.169 34.096H336.4v1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M319.169 34.096H336.4v1h-17.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M320.15 54.403h15.269v-1.422H320.15z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M320.15 54.403h15.269v-1H320.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M319.169 55.716H336.4v-1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M319.169 55.716H336.4v-1h-17.231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M242.704 65.736h11.673v18.137h-11.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M243.866 65.736h9.349v18.137h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__s)",
    d: "M3.855 1.883h9.349V20.02H3.855z",
    transform: "translate(240.011 63.853)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9EA8",
    d: "M243.866 65.736h9.349v9.069h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M240.992 65.166h15.269v1.422h-15.269z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M240.992 65.166h15.269v1h-15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M240.011 63.853h17.231v1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M240.011 63.853h17.231v1h-17.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M240.992 84.16h15.269v-1.422h-15.269z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M240.992 84.16h15.269v-1h-15.269z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M240.011 85.473h17.231v-1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M240.011 85.473h17.231v-1h-17.231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M321.862 65.736h11.673v18.137h-11.673z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#585BA6",
    d: "M323.024 65.736h9.349v18.137h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#hotel-detail-failed_svg__s)",
    d: "M3.855 1.883h9.349V20.02H3.855z",
    transform: "translate(319.169 63.853)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9EA8",
    d: "M323.024 65.736h9.349v9.069h-9.349z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M320.15 65.166h15.269v1.422H320.15z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M320.15 65.166h15.269v1H320.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M319.169 63.853H336.4v1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M319.169 63.853H336.4v1h-17.231z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M320.15 84.16h15.269v-1.422H320.15z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M320.15 84.16h15.269v-1H320.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FB5368",
    d: "M319.169 85.473H336.4v-1.422h-17.231z",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M319.169 85.473H336.4v-1h-17.231z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B43461",
    d: "M282.153 18.496h11.946v17.315h-11.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9EA8",
    d: "M282.153 18.496h11.946v8.658h-11.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M281.188 18.496h13.875v1.332h-13.875zm0 16.649h13.876v1.332h-13.876z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B43461",
    d: "M282.153 49.012h11.946v17.315h-11.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9EA8",
    d: "M282.153 49.012h11.946v8.658h-11.946z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9D294D",
    d: "M281.188 49.012h13.875v1.332h-13.875zm0 16.649h13.876v1.332h-13.876z"
  })))));
}
export default SvgHotelDetailFailed;